{
  "nav": {
    "chat": "Session",
    "agents": "Agents",
    "history": "History",
    "files": "Files",
    "changes": "Changes",
    "mailbox": "Mailbox",
    "skills": "Skills",
    "worktrees": "Worktrees",
    "design": "Design Studio",
    "officemap": "Office Map",
    "settings": "Settings",
    "sddwizard": "New SDD Project",
    "specs": "Specs",
    "sddboard": "Live Board",
    "autophase": "Phases",
    "fleet": "Fleet",
    "inspector": "Inspector",
    "prompts": "Prompts"
  },
  "brand": {
    "returnToChat": "{{name}} — return to chat",
    "returnToChatDefault": "WrongStack — return to chat"
  },
  "status": {
    "connected": "Connected",
    "disconnected": "Disconnected",
    "idle": "Idle",
    "thinking": "Thinking",
    "running": "Running",
    "waiting": "Waiting",
    "done": "Done",
    "stopped": "Stopped"
  },
  "menu": {
    "moreWithHidden": "More, {{count}} hidden items",
    "moreOptions": "More options",
    "moreCompactHidden": "More — {{count}} hidden panels/views, palette, theme, monitors",
    "moreCompact": "More — palette, theme, monitors",
    "moreFull": "More — palette, theme, shortcuts, monitors",
    "commandPalette": "Command Palette",
    "keyboardShortcuts": "Keyboard Shortcuts",
    "panels": "Panels",
    "views": "Views",
    "theme": "Theme",
    "monitors": "Monitors",
    "fleetMonitor": "Fleet Monitor",
    "agentsMonitor": "Agents Monitor"
  },
  "sidePanel": {
    "dragHint": "Drag to resize · double-click to reset",
    "collapse": "Collapse panel (Ctrl+\\)"
  },
  "history": {
    "openDashboard": "Open sessions dashboard"
  },
  "agents": {
    "pending": "pending…",
    "empty": "No agents yet",
    "emptyHint": "Subagents appear here when the fleet is active.",
    "runningCount": "{{count}} running",
    "totalCount": "{{count}} total",
    "openFull": "Open full agents view",
    "agentsLive": "AGENTS · LIVE",
    "doneCount": "{{count}} done",
    "failedCount": "{{count}} failed",
    "modelsLabel": "models",
    "shownLabel": "shown",
    "totalLabel": "total",
    "leaderFleetTotals": "(leader {{leader}} · fleet {{fleet}})",
    "navHintJk": "j/k or ↑↓ to navigate",
    "escCloseDetail": "· Esc to close detail",
    "noAgentsRunning": "No agents running.",
    "contextUsage": "Context Usage",
    "lastToolLabel": "last:",
    "unknownSession": "Unknown session",
    "sessionCopyTitle": "Session: {{sid}} — click to copy ID",
    "sessionWord": "session",
    "agentsCountSuffix_one": "{{count}} agent",
    "agentsCountSuffix_other": "{{count}} agents",
    "sessionTitle": "Session: {{sid}}",
    "projectSuffix": " · Project: {{name}}",
    "statusIdle": "idle"
  },
  "changes": {
    "fileCount_one": "{{count}} file",
    "fileCount_other": "{{count}} files",
    "refreshTitle": "Refresh changes",
    "loading": "Loading changes…",
    "clean": "No changes — working tree is clean.",
    "selectPrompt": "Select a changed file to view its diff.",
    "unified": "Unified",
    "unifiedTitle": "Unified diff",
    "edit": "Edit",
    "editTitle": "Side-by-side editable diff",
    "loadingDiff": "Loading diff…",
    "binary": "Binary file — diff not shown.",
    "tooLarge": "File too large to diff."
  },
  "inspector": {
    "showPanel": "Show inspector panel (Fleet / Agents / Audit)",
    "hidePanel": "Hide inspector panel",
    "label": "Inspector",
    "openAudit": "Open Audit tab",
    "tabFleet": "Fleet",
    "tabAgents": "Agents",
    "tabAudit": "Audit",
    "collapseAria": "Collapse inspector panel",
    "collapseTitle": "Collapse (Esc)",
    "noAgentsActive": "No agents active",
    "agentsAppearHint": "Agents appear here when the fleet is active.",
    "selected": "{{name}} (selected)"
  },
  "nextSteps": {
    "header": "Next steps",
    "autoSubmitting": "auto-submitting in",
    "clickToFill": "click to fill input",
    "clickToFillTitle": "Click to fill: {{text}}",
    "auto": "auto",
    "willAutoSubmit": "Will auto-submit after countdown"
  },
  "mailbox": {
    "onlineCount": "{{count}} online",
    "messages": "Messages",
    "deleteAllTitle": "Delete all messages",
    "deleteAll": "Delete all",
    "deleting": "Deleting…",
    "purgeTitle": "Purge stale/orphaned messages",
    "purge": "Purge",
    "purging": "Purging…",
    "newLabel": "NEW",
    "empty": "No messages yet.",
    "offlineCount": "+{{count}} offline",
    "timeNow": "now",
    "deleteAllConfirmTitle_one": "Delete {{count}} message?",
    "deleteAllConfirmTitle_other": "Delete all {{count}} messages?",
    "deleteAllConfirmBody": "The mailbox file is truncated for every agent. This cannot be undone.",
    "purgeConfirmTitle": "Purge stale messages?",
    "purgeConfirmBody": "Removes completed messages older than 1 day and incomplete messages older than 7 days. Active messages are preserved.",
    "type": {
      "note": "Note",
      "ask": "Question",
      "assign": "Assignment",
      "steer": "Steer",
      "btw": "By the way",
      "broadcast": "Broadcast",
      "status": "Status",
      "result": "Result"
    },
    "emptyDetail": "No message selected",
    "emptyDetailHint": "Click a message in the Mailbox panel to view it here.",
    "readBy": "Read by",
    "backToChat": "Back to chat",
    "completed": "Completed",
    "everyone": "everyone",
    "closeTitle": "Close (Esc)",
    "replyTo": "In reply to: {{id}}",
    "completedBy": "Completed by {{name}}",
    "completedByAt": "Completed by {{name}} at {{time}}",
    "outcome": "Outcome:",
    "task": "Task:",
    "messageNotFound": "Message not found",
    "messageNotFoundHint": "This message may have been deleted or purged."
  },
  "sessions": {
    "recentSessions": "Recent sessions",
    "deleteEmptyTitle_one": "Delete {{count}} empty session?",
    "deleteEmptyTitle_other": "Delete {{count}} empty sessions?",
    "deleteEmptyConfirmBody": "Sessions without any token usage are removed from disk.",
    "filterPlaceholder": "Filter title, model, provider…",
    "clearFilter": "Clear filter",
    "noHistory": "No history yet",
    "noHistoryHint": "Your conversations will appear here",
    "noMatches": "No matches",
    "noMatchesHint": "Try a different filter",
    "group": {
      "favorites": "Favorites",
      "today": "Today",
      "yesterday": "Yesterday",
      "thisWeek": "This week",
      "earlier": "Earlier"
    },
    "nicknamePlaceholder": "Nickname",
    "empty": "(empty)",
    "resuming": "resuming…",
    "active": "active",
    "renameTitleNickname": "{{nickname}} — original: {{title}}",
    "renameTitle": "{{title}}\n\nDouble-click to rename",
    "unfavorite": "Unfavorite",
    "markFavorite": "Mark as favorite",
    "deleteSessionConfirmTitle": "Delete session?",
    "deleteSessionConfirmBody": "\"{{name}}\" will be removed from disk. This cannot be undone.",
    "deleteSessionTitle": "Delete session"
  },
  "sessionPanel": {
    "actions": {
      "abort": "Abort",
      "newSession": "New session",
      "export": "Export",
      "compact": "Compact",
      "newSessionTitle": "Start a new session (Ctrl+N)",
      "exportTitle": "Export chat as markdown (Ctrl+E)",
      "compactTitle": "Compact the context window",
      "clearTitle": "Clear context (Ctrl+L)"
    },
    "model": "Model",
    "modelTitle": "Change model (Ctrl+M)",
    "context": "Context",
    "contextTitle": "Click for a context breakdown",
    "sessionLabel": "Session",
    "stats": {
      "messages": "Messages",
      "elapsed": "Elapsed",
      "tokens": "Tokens",
      "cost": "Cost",
      "iteration": "Iteration",
      "agents": "Agents",
      "tokensSub": "{{in}} in / {{out}} out",
      "iterationOf": "of {{max}}",
      "agentsRunning": "{{count}} running"
    },
    "plan": "Plan",
    "planComplete": "{{pct}}% complete",
    "pinned": "Pinned",
    "quickSettings": "Quick settings",
    "autonomy": "Autonomy",
    "autonomyOptions": {
      "off": "Off",
      "suggest": "Suggest",
      "auto": "Auto",
      "eternal": "Eternal",
      "eternal-parallel": "Eternal Parallel"
    },
    "yolo": "YOLO mode",
    "yoloTitle": "Bypass tool confirmation prompts",
    "refine": "Refine prompts",
    "refineTitle": "Rewrite prompts before sending",
    "sound": "Sound on completion",
    "soundTitle": "Play a soft chime when a run finishes",
    "sessionId": "session {{id}}"
  },
  "fleet": {
    "status": {
      "running": "running",
      "done": "done",
      "failed": "failed",
      "timeout": "timeout",
      "stopped": "stopped"
    },
    "leader": "leader",
    "providerModel": "Provider / Model",
    "elapsed": "Elapsed",
    "running": "running…",
    "iterations": "Iterations",
    "toolCalls": "Tool Calls",
    "cost": "Cost",
    "budgetExtensions": "Budget Extensions",
    "activity": "Activity",
    "budgetWarning": "budget warning",
    "contextWindow": "Context window",
    "tokensUsed": "{{used}} / {{max}} tokens",
    "toolRunning": "running…",
    "lastTool": "last tool",
    "error": "Error",
    "finalOutput": "Final Output",
    "copyOutput": "Copy output",
    "liveOutput": "Live Output",
    "waitingOutput": "Waiting for output…",
    "outputHint": "Output appears here as the agent streams text.",
    "toolLog": "Tool Log ({{count}} calls)",
    "fail": "fail",
    "moreTools": "+{{count}} more tools",
    "cardRunning": "running {{tool}}",
    "cardLastTool": "last: {{tool}}",
    "contextPercent": "Context {{pct}}%",
    "doneCount": "{{count}} done",
    "errCount": "{{count}} err",
    "statusRunning": "running",
    "statusDone": "done",
    "statusFailed": "failed",
    "statusTimeout": "timeout",
    "statusStopped": "stopped",
    "sessionPrefix": "session:",
    "currentTask": "Current Task",
    "performance": "Performance",
    "uniqueTools": "Unique Tools",
    "avgPerTool": "avg {{ms}}ms per tool",
    "context": "Context",
    "tokens": "Tokens",
    "ctxUsed": "{{pct}}% used",
    "completed": "completed",
    "budgetWarningTitle": "⚡ Budget Warning",
    "hittingLimit": "Hitting {{kind}} limit ({{used}}/{{limit}})",
    "hittingLimitTitle": "⚡ hitting {{kind}} limit ({{used}}/{{limit}})",
    "budgetExt_one": "{{count}} Budget Extension",
    "budgetExt_other": "{{count}} Budget Extensions",
    "extendedTimes_one": "Agent extended its budget {{count}} time due to long-running tasks",
    "extendedTimes_other": "Agent extended its budget {{count}} times due to long-running tasks",
    "errorLabel": "Error",
    "failureReason": "Failure Reason",
    "failed": "Failed",
    "fleetMonitor": "FLEET MONITOR",
    "runningCount": "{{count}} running",
    "totalAgents_one": "{{count}} total agent",
    "totalAgents_other": "{{count}} total agents",
    "noLeader": "no leader",
    "closeFleet": "Close fleet monitor",
    "colName": "Name",
    "colStatus": "Status",
    "colActivity": "Activity",
    "colIters": "Iters",
    "colTools": "Tools",
    "colCost": "Cost",
    "colCtx": "CTX",
    "colExt": "Ext",
    "colReason": "Reason",
    "noAgentsActive": "No agents active",
    "agentsAppear": "Agents appear here when the fleet is active.",
    "agentTimeline": "Agent Timeline",
    "noAgentEvents": "No agent conversation events yet.",
    "navHint": "↑↓ navigate",
    "selectDetailHint": "↵ select detail",
    "escHint": "Esc deselect / close",
    "detailedView": "detailed view",
    "closeBtn": "✕ close",
    "selectAgentDetail": "Select an agent to view detailed information",
    "selectAgentBody": "Click on any agent in the list to see detailed metrics, tool logs, streaming output, and more — similar to the chat history detailed view.",
    "navigateWord": "navigate",
    "selectWord": "select",
    "deselectWord": "deselect"
  },
  "context": {
    "wsNotConnected": "WebSocket not connected",
    "noData": "No debug data received. The server may not support context debugging.",
    "title": "Context Breakdown",
    "windowUsage": "Window Usage",
    "contextMode": "Context Mode",
    "fetching": "Fetching context breakdown…",
    "systemPrompt": "System Prompt",
    "tools": "Tools",
    "messages": "Messages",
    "tokenAllocation": "Token Allocation",
    "systemTitle": "System: {{tokens}}",
    "toolsTitle": "Tools: {{tokens}}",
    "messagesTitle": "Messages: {{tokens}}",
    "system": "System",
    "toolBreakdown": "Tool Breakdown",
    "messagesSummary": "Messages ({{count}}) — {{total}} tok",
    "barWithTokens": "Context window: {{tokens}} / {{max}} tokens ({{pct}})",
    "barPct": "Context window: {{pct}}",
    "barClick": " — click for breakdown"
  },
  "refine": {
    "header": "✨ Refine Prompt",
    "autoSend": "auto-send in {{count}}s",
    "cancelTitle": "Cancel (Esc)",
    "editLabel": "Edit refined prompt:",
    "editPlaceholder": "Edit the refined prompt...",
    "useEdit": "Use Edit",
    "original": "Original",
    "refined": "Refined",
    "yourLanguage": "(your language)",
    "refinedTitle": "Click or press Enter to use this version",
    "english": "English",
    "englishTitle": "Press e to use English version",
    "hintRefined": "refined",
    "hintEnglish": "English",
    "hintOriginal": "original",
    "hintEdit": "edit",
    "edit": "Edit",
    "useRefined": "Use Refined"
  },
  "specs": {
    "heading": "Specifications",
    "subtitle": "View and manage specification-driven development",
    "empty": "No specs found. Use {{command}} to create one.",
    "tasks": "Tasks ({{count}})",
    "doneCount": "{{count}} done",
    "runningCount": "{{count}} running",
    "pendingCount": "{{count}} pending",
    "runTitle": "Run this spec as a live AutoPhase board",
    "run": "Run",
    "list": "List",
    "graph": "Graph",
    "loadingTasks": "Loading tasks…"
  },
  "refresh": {
    "heading": "F5 Resilience Verifier",
    "subtitle": "Confirms the latest active session, transcript, and UI state survive a page refresh. Open this view, then press F5 — every green row should remain green.",
    "recordProbe": "Record probe",
    "latestSession": "Latest active session",
    "restoredLocal": "Restored from localStorage",
    "sessionIdExtra": "session id: {{id}}",
    "noSessionYet": "no session has been started yet",
    "activePointer": "Active session pointer",
    "lastVisited": "lastVisitedAt timestamp",
    "never": "never",
    "persistedEnv": "Persisted environment",
    "transcriptRehydrate": "Chat transcript rehydration",
    "localTranscript": "Local transcript recovered",
    "messagesExtra": "{{count}} messages, {{queued}} queued",
    "noMessages": "0 messages",
    "noBleed": "No cross-session bleed",
    "bleedExtra": "bound={{bound}} vs active={{active}}",
    "transcriptBinds": "transcript binds to the active session",
    "uiWorkspace": "UI workspace",
    "noneValue": "(none)",
    "payloadSize": "localStorage payload (4 keys): {{count}} chars",
    "probeLog": "Probe log",
    "noProbes": "No probes yet — press the \"Record probe\" button at the top, or press F5 in this view, to record a rehydration check.",
    "simulatedF5": "simulated F5: re-running persist rehydrate"
  },
  "board": {
    "status": {
      "pending": "Pending",
      "in_progress": "In Progress",
      "review": "Review",
      "failed": "Failed",
      "completed": "Done",
      "queued": "Queued",
      "blocked": "Blocked",
      "cancelled": "Cancelled"
    },
    "newTaskTitle": "New task",
    "newTaskPlaceholder": "Task title…",
    "addTask": "Add task",
    "empty": "No phases yet — start an AutoPhase run to populate the board.",
    "summary": "{{phases}} phases · {{tasks}} tasks",
    "phases": "Phases",
    "statusTab": "Status",
    "dropHere": "Drop tasks here",
    "emptySpec": "No tasks in this spec yet.",
    "depGraphHeading": "Dependency Graph",
    "worktreePrefix": "worktree: {{branch}}"
  },
  "debug": {
    "trendUp": "Increasing",
    "trendDown": "Decreasing",
    "trendStable": "Stable",
    "heading": "Debug Dashboard",
    "subtitle": "Real-time monitoring for WrongStack WebUI",
    "refreshLabel": "Refresh:",
    "lastUpdated": "Last updated: {{time}}",
    "fetchFailed": "Failed to fetch metrics",
    "fileWatcher": "File Watcher",
    "watcherStatus": "Watcher Status",
    "running": "Running",
    "stopped": "Stopped",
    "activeProjects": "Active Projects",
    "projectsWatched": "Projects being watched",
    "fileChanges": "File Changes",
    "totalDetected": "Total detected",
    "filesProcessed": "Files Processed",
    "afterHash": "After hash filter",
    "broadcastsSent": "Broadcasts Sent",
    "toClients": "To WebUI clients",
    "debounceResets": "Debounce Resets",
    "rapidWrites": "Rapid successive writes",
    "avgDebounce": "Avg Debounce Delay",
    "actualDelay": "Actual delay applied",
    "totalDelay": "Total Delay",
    "sumDelays": "Sum of all delays",
    "browserPerf": "Browser Performance",
    "heapUsed": "Heap Used",
    "jsHeap": "JavaScript heap",
    "heapTotal": "Heap Total",
    "totalHeap": "Total heap size",
    "pageUptime": "Page Uptime",
    "sinceLoad": "Since page load",
    "rawData": "Raw Data"
  },
  "providerModels": {
    "using": "Using",
    "noModelPicked": "(no model picked)",
    "clearAllowlist": "Clear allowlist",
    "clearAllowlistAria": "Clear saved allowlist for {{provider}}",
    "refresh": "Refresh from server",
    "refreshAria": "Refresh model list for {{provider}}",
    "probing": "Probing…",
    "use": "Use",
    "useModelAria": "Use model {{model}} for {{provider}}",
    "differsHint": "Probed list differs from the saved allowlist — re-run {{command}} to persist."
  },
  "dock": {
    "expandChip": "Expand {{label}}",
    "collapseChip": "Collapse {{label}}",
    "ahead": "{{count}} ahead",
    "behind": "{{count}} behind",
    "linesAdded": "{{count}} lines added",
    "linesDeleted": "{{count}} lines deleted",
    "untrackedFiles": "{{count}} untracked files",
    "customizeTitle": "Customize dock chips",
    "dockChips": "Dock chips",
    "noActiveGoal": "No active goal",
    "noActiveGoalDetail": "Start a goal from chat or the goal command."
  },
  "agentsMonitor": {
    "leaderBadge": "LEADER",
    "iters": "Iters",
    "tools": "Tools",
    "activityBins": "Activity (12 bins)",
    "streamingOutput": "Streaming output",
    "recentTools": "Recent tools",
    "finalOutput": "Final output",
    "heading": "Agents Monitor",
    "prevAgent": "Previous agent",
    "nextAgent": "Next agent",
    "closeAria": "Close agents monitor",
    "hintPage": "←→ page",
    "hintNavigate": "↑↓ navigate list",
    "hintEsc": "Esc close"
  },
  "terminal": {
    "resize": "Resize terminals",
    "labelSingular": "Terminal",
    "labelPlural": "Terminals",
    "projectShell": "Project shell",
    "maxTerminals": "Maximum {{count}} terminals",
    "newTerminal": "New terminal",
    "restart": "Restart active terminal",
    "closeAll": "Close all terminals",
    "closeDock": "Close terminal dock (Ctrl+`)",
    "closeTab": "Close {{name}}",
    "processExited": "[process exited with code {{code}}]"
  },
  "sessionWatch": {
    "liveStream": "Live stream",
    "events_one": "{{count}} event",
    "events_other": "{{count}} events",
    "interruptTitle": "Cooperatively stop this agent at its next step (not a process kill)",
    "interrupt": "⏸ Interrupt",
    "interrupting": "…",
    "loading": "Loading session…",
    "done": "✓✓ done",
    "read": "✓ read",
    "delivered": "⏳ delivered",
    "agent": "Agent",
    "you": "You",
    "working": "{{name}} · working",
    "claude": "Claude",
    "priority": "Priority",
    "placeholder": "{{label}} → this session…",
    "send": "Send",
    "sendHint": "⌘/Ctrl+Enter to send · seen on the agent's next iteration",
    "msgType": {
      "steerLabel": "🔄 Steer",
      "steerHint": "Adjust behavior mid-task",
      "askLabel": "❓ Ask",
      "askHint": "Question — expects a reply",
      "assignLabel": "📋 Assign",
      "assignHint": "A task to act on",
      "noteLabel": "💬 Note",
      "noteHint": "FYI, non-urgent"
    },
    "sentRunning": "Delivered — the running agent sees it on its next step",
    "sentIdle": "Delivered — target is idle; appears in its mailbox, read when it next runs",
    "sentFailed": "Failed: {{error}}",
    "interruptReason": "Operator requested stop from Fleet HQ",
    "interruptSent": "Interrupt sent — agent stops at its next step (not a kill)",
    "interruptFailed": "Interrupt failed: {{error}}"
  },
  "sideEffects": {
    "empty": "No side effects recorded yet.",
    "emptyHint": "Bash commands, package installs, and network requests will appear here.",
    "heading": "Side Effects",
    "exportTitle": "Export filtered side effects as CSV",
    "all": "All",
    "colTime": "Time",
    "colTool": "Tool",
    "colRisk": "Risk",
    "colDetail": "Detail",
    "colOutcome": "Outcome"
  },
  "monitor": {
    "elapsedHm": "{{h}}h {{m}}m ago",
    "elapsedMs": "{{m}}m {{s}}s ago",
    "elapsedS": "{{s}}s ago",
    "heading": "Fleet Monitor",
    "clientsHeading": "Connected Clients",
    "terminal": "Terminal",
    "webui": "Web UI",
    "repl": "REPL",
    "totalConnected": "total connected",
    "mailQueue": "Mail Queue",
    "total": "Total",
    "open": "Open",
    "unread": "Unread",
    "agents": "Agents",
    "messagesSub": "messages",
    "uncompletedSub": "uncompleted",
    "waitingSub": "waiting",
    "ofTotal": "of {{count}} total",
    "agentRoster": "Agent Roster",
    "liveMailActivity": "Live Mail Activity",
    "noActivity": "No recent activity",
    "mailboxAgents": "Mailbox Agents",
    "noMailboxAgents": "No agents registered",
    "moreCount": "+{{count}} more",
    "agentFallback": "agent",
    "fleetAgents": "Fleet Agents",
    "noFleetAgents": "No fleet agents running",
    "iter": "iter",
    "mailType": {
      "sent": "Sent",
      "delivered": "Delivered",
      "read": "Read",
      "completed": "Completed"
    }
  },
  "sdd": {
    "status": {
      "pending": "pending",
      "queued": "queued",
      "in_progress": "running",
      "blocked": "blocked",
      "review": "review",
      "failed": "failed",
      "completed": "done",
      "cancelled": "cancelled"
    },
    "activityHeading": "Activity",
    "feedEmpty": "Nothing yet — events appear here as agents pick up and finish tasks.",
    "destroyTitle": "Destroy SDD project?",
    "destroyDesc": "This wipes the run and its work. It cannot be undone (the optional commit revert is history-preserving).",
    "stopRun": "Stop the run",
    "stopRunAgents_one": "Stop the run ({{count}} agent working)",
    "stopRunAgents_other": "Stop the run ({{count}} agents working)",
    "removeWorktreesAll": "Remove all git worktrees + wstack/ap/* branches — including un-merged work",
    "removeWorktreesCount_one": "Remove {{count}} git worktree + wstack/ap/* branches — including un-merged work",
    "removeWorktreesCount_other": "Remove {{count}} git worktrees + wstack/ap/* branches — including un-merged work",
    "deleteArtifacts": "Delete all SDD artifacts (specs, task graph, board, session)",
    "revertMerged_one": "Also revert {{count}} merged commit",
    "revertMerged_other": "Also revert {{count}} merged commits",
    "revertHint": "Adds revert commits (history preserved). Refused if the working tree is dirty.",
    "baseBranchFallback": "the base branch",
    "noteLeaveMerged": "Merged commits will be left on the base branch. Tick the box above to undo them too.",
    "noteAbandon": "Make sure you really want to abandon this run.",
    "destroying": "Destroying…",
    "destroyAll": "Destroy everything",
    "kanbanBacklog": "Backlog",
    "kanbanReady": "Ready",
    "kanbanRunning": "Running",
    "kanbanReview": "Review",
    "kanbanFailed": "Failed",
    "kanbanDone": "Done",
    "kanbanEmpty": "empty"
  },
  "toolResult": {
    "collapseToLines": "Collapse to first {{count}} lines",
    "showAllLines": "Show all {{total}} lines ({{more}} more)",
    "exitCode": "exit code:",
    "jsonLines": "JSON · {{count}} lines",
    "collapse": "collapse",
    "expand": "expand"
  },
  "design": {
    "heading": "Design Studio — Gallery",
    "kitsCount": "{{count}} kits",
    "searchPlaceholder": "Search kits…",
    "stackTitle": "Stack for Use + Materialize",
    "wrote": "Wrote {{path}}",
    "materializeFailed": "Materialize failed: {{error}}",
    "verifyError": "Verify: {{error}}",
    "verifyOffPalette": "Verify: {{pct}}% on-palette — {{count}} off-palette in {{files}} file(s)",
    "verifyClean": "Verify: clean ✓ ({{files}} file(s) on-palette)",
    "writing": "Writing theme file…",
    "scanning": "Scanning UI files…",
    "active": "Active",
    "reapply": "Reapply",
    "use": "Use",
    "materializeTitle": "Write tokens to a {{stack}} theme file",
    "materialize": "Materialize",
    "verifyTitle": "Scan UI files for off-palette colors",
    "verify": "Verify",
    "colors": "Colors"
  },
  "autoPhase": {
    "summary_one": "{{count}} phase · {{pct}}% complete",
    "summary_other": "{{count}} phases · {{pct}}% complete",
    "switchBoard": "Switch board",
    "boardsCount_one": "{{count}} board…",
    "boardsCount_other": "{{count}} boards…",
    "toggleAutonomousTitle": "Toggle autonomous mode",
    "autonomous": "Autonomous",
    "manual": "Manual",
    "resumeTitle": "Resume the run",
    "pauseTitle": "Pause the run",
    "resume": "Resume",
    "pause": "Pause",
    "stopTitle": "Stop the run — aborts in-flight agents immediately",
    "stop": "Stop",
    "newTitle": "Clear this board and start a new AutoPhase run",
    "newLabel": "New",
    "revertConfirm": "Revert run's commits?",
    "revertTitle": "Undo this run — git-revert the commits it landed and remove its worktrees",
    "revert": "Revert",
    "goal": "Goal",
    "planning": "Planning phases…",
    "planningBody": "Your goal was received. WrongStack is breaking it into phases and tasks — the board appears here the moment the plan is ready.",
    "startHeading": "Start a Phase Plan",
    "startBody": "Describe what you want to build. WrongStack will plan phases and tasks, then execute them — watch and steer the run on the board.",
    "startPlaceholder": "e.g. Build a REST API for user management with Express and SQLite...",
    "isolateLabel": "Isolate each phase in its own git worktree",
    "startButton": "Start AutoPhase",
    "ctrlHint": "Ctrl+Enter to start",
    "isolateOn": "phases run in isolated worktrees, squash-merged back",
    "isolateOff": "phases run directly on the current branch",
    "lanes": "Lanes",
    "graph": "Graph",
    "planningAck": "🚀 **AutoPhase** — got it. Planning phases for your goal now…"
  },
  "collab": {
    "noObservers": "No live observers",
    "observerTitle": "Join as a read-only observer (Phase 1)",
    "observerRole": "observer",
    "annotatorTitle": "Join as an annotator — leave inline notes on tool calls (Phase 2)",
    "annotatorRole": "annotator",
    "controllerTitle": "Join as a controller — can pause the agent loop (Phase 3)",
    "controllerRole": "controller",
    "errorPrefix": "Collab: {{error}}",
    "dismiss": "dismiss",
    "observers_one": "{{count}} observer",
    "observers_other": "{{count}} observers",
    "annotationsTitle": "{{count}} open annotation(s) — annotators reviewing this session",
    "notes_one": "{{count}} note",
    "notes_other": "{{count}} notes",
    "pausedTitle": "Agent loop is paused — a controller is reviewing",
    "paused": "paused",
    "joinedTitle": "Joined {{time}}",
    "grantTitle": "Grant control — promote this participant to controller",
    "injectTitle": "Inject a synthetic result for an in-flight tool call",
    "inject": "Inject",
    "resumeTitle": "Resume the agent loop",
    "resume": "Resume",
    "pauseTitle": "Pause the agent before the next tool call",
    "pauseAgent": "Pause agent",
    "leaveTitle": "Leave the observer session",
    "leave": "Leave",
    "injectToolResult": "Inject tool result",
    "close": "close",
    "targetTool": "Target tool_use id",
    "targetPlaceholder": "pick an in-flight call or type a tool_use id",
    "toolFallback": "tool",
    "noPendingTools": "No in-flight tool calls — type a tool_use id to pre-queue, or pause the agent first.",
    "resultContent": "Result content",
    "resultPlaceholder": "Synthetic tool result fed to the agent in place of running the tool",
    "markError": "mark as error",
    "reasonPlaceholder": "reason (audit log)",
    "queueInjection": "Queue injection",
    "controllerInjection": "controller injection"
  },
  "connection": {
    "reconnecting": "Reconnecting to backend (attempt {{attempt}}) — retrying in {{remaining}}s",
    "disconnected": "Disconnected from backend",
    "retry": "Retry now",
    "retryTitle": "Retry connection now",
    "dismissTitle": "Dismiss (chip in topbar still shows status)"
  },
  "mode": {
    "modePrefix": "mode:",
    "activeTitle": "Active mode",
    "heading": "Mode",
    "defaultName": "Default",
    "defaultDesc": "Standard agent behaviour"
  },
  "cost": {
    "clickTitle": "Click for per-turn cost breakdown",
    "heading": "Cost breakdown",
    "noPricing": "No pricing for the current model — cost figures are zero.",
    "noTurns": "No completed turns yet. Run a prompt to see per-turn cost here.",
    "topExpensive_one": "Top {{count}} expensive turn",
    "topExpensive_other": "Top {{count}} expensive turns"
  },
  "model": {
    "runDefault": "Run default",
    "useRunDefault": "Use run default",
    "filterPlaceholder": "Filter models…",
    "loading": "Loading models…",
    "noMatch": "No match"
  },
  "modelSwitcher": {
    "heading": "Switch model",
    "filterPlaceholder": "Filter providers and models…",
    "noSavedProviders": "No saved providers — register a key in Settings first.",
    "active": "active"
  },
  "work": {
    "todos": "Todos",
    "tasks": "Tasks",
    "plan": "Plan"
  },
  "todos": {
    "toggleAria": "Toggle: {{content}}",
    "removeTitle": "Remove todo",
    "removeAria": "Remove \"{{content}}\"",
    "completedCount_one": "{{count}} completed",
    "completedCount_other": "{{count}} completed"
  },
  "task": {
    "start": "Start",
    "complete": "Complete",
    "retry": "Retry",
    "assign": "Assign",
    "assignTitle": "Assign agent",
    "unassigned": "Unassigned",
    "statusPending": "Pending",
    "statusInProgress": "In Progress",
    "statusBlocked": "Blocked",
    "statusFailed": "Failed",
    "statusReview": "Review",
    "statusDone": "Done",
    "startTitle": "Start",
    "completeTitle": "Complete",
    "fail": "Fail",
    "failTitle": "Mark failed",
    "boardCount": "{{total}} tasks · {{done}} completed"
  },
  "toolGroup": {
    "toolCalls_one": "{{count}} tool call",
    "toolCalls_other": "{{count}} tool calls"
  },
  "fileRef": {
    "removeTitle": "Remove reference",
    "linesCount_one": "{{count}} line",
    "linesCount_other": "{{count}} lines"
  },
  "plan": {
    "statusOpen": "Open",
    "statusInProgress": "In Progress",
    "statusDone": "Done",
    "startTitle": "Start",
    "doneTitle": "Mark done",
    "reopenTitle": "Reopen",
    "reopen": "Reopen"
  },
  "filePicker": {
    "heading": "@ Files",
    "noMatch": "No files match \"{{query}}\"",
    "searching": "Searching project…"
  },
  "toast": {
    "dismiss": "Dismiss"
  },
  "search": {
    "placeholder": "Search in chat…",
    "prevHit": "Previous hit",
    "nextHit": "Next hit",
    "close": "Close (Esc)"
  },
  "phase": {
    "statusPending": "Pending",
    "statusReady": "Ready",
    "statusRunning": "Running",
    "statusPaused": "Paused",
    "statusCompleted": "Completed",
    "statusFailed": "Failed",
    "statusSkipped": "Skipped",
    "heading": "Phases",
    "autonomousOn": "● Autonomous",
    "autonomousOff": "○ Manual",
    "autonomousOnTitle": "Autonomous mode active — click to pause",
    "autonomousOffTitle": "Manual mode — click to enable autonomous",
    "overallProgress": "Overall Progress",
    "tasksSuffix": "{{done}}/{{total}} tasks",
    "agentsSuffix_one": "{{count}} agent",
    "agentsSuffix_other": "{{count}} agents"
  },
  "ctxMode": {
    "triggerTitle": "Context-window mode",
    "ctxPrefix": "ctx:",
    "opsHeading": "Context Operations",
    "compactNow": "Compact Now",
    "compactNowDesc": "Elide old tool output",
    "compactAggressive": "Compact Aggressive",
    "compactAggressiveDesc": "Maximum elision now",
    "repairContext": "Repair Context",
    "repairDesc": "Fix orphan tool-use blocks",
    "debugContext": "Debug Context",
    "debugDesc": "Size breakdown per section",
    "windowHeading": "Context Window",
    "keepElide": "keep {{k}} recent · elide {{t}}+ tokens",
    "fallbackName": "Balanced",
    "fallbackDesc": "Default rolling compaction"
  },
  "transcript": {
    "kindAssistant": "Assistant",
    "kindThinking": "Thinking",
    "kindToolCall": "Tool call",
    "kindToolResult": "Tool result",
    "kindError": "Error",
    "kindStatus": "Status",
    "kindSystem": "System",
    "title": "Chat history",
    "copyTitle": "Copy agent chat history",
    "empty": "No chat history for this agent yet."
  },
  "autonomy": {
    "heading": "Autonomy Mode",
    "titlePrefix": "Autonomy: {{label}}",
    "descOff": "Full manual control — agent waits for your input.",
    "descSuggest": "Agent suggests next steps but waits for approval.",
    "descAuto": "Agent auto-proceeds after brief confirmation delay.",
    "descEternal": "Agent runs autonomously until goal is complete.",
    "descEternalParallel": "Multi-agent autonomous execution — fleet mode."
  },
  "queue": {
    "heading": "Message Queue",
    "subtitle": "{{count}} queued · messages sent before the agent finishes",
    "btwTitle": "By-the-way — sent as follow-up without interrupting the running agent",
    "steerTitle": "Steer — interrupts the running agent and redirects it with this message",
    "queueTitle": "Queued — held until the current agent run completes, then sent in order",
    "sortNewestTitle": "Sorted newest first — click to sort oldest first",
    "sortOldestTitle": "Sorted oldest first — click to sort newest first",
    "newest": "Newest",
    "oldest": "Oldest",
    "clear": "Clear",
    "clearTitle": "Clear all queued messages",
    "closeTitle": "Close",
    "emptyTitle": "Queue is empty",
    "emptyBody": "Use the btw / steer / add queue buttons beside the input to add messages. Queued items are sent in order when the current agent run completes.",
    "removeTitle": "Remove from queue",
    "footer": "Messages are sent in arrival order when the current agent run completes. Use the sort toggle to view newest-first."
  },
  "checkpoint": {
    "heading": "Session Checkpoints",
    "countSuffix_one": "{{count}} checkpoint",
    "countSuffix_other": "{{count}} checkpoints",
    "description": "Rewind the session to any checkpoint. Messages and file changes revert to that point — the LLM continues from there as if nothing happened after.",
    "emptyTitle": "No checkpoints yet",
    "emptyBody": "Checkpoints are automatically created each time you send a message. Send a few messages and come back.",
    "latest": "latest",
    "msgSuffix_one": "{{count}} msg",
    "msgSuffix_other": "{{count}} msgs",
    "footerPre": "Click any checkpoint to rewind",
    "footerPost": "to close"
  },
  "goal": {
    "statusActive": "Active",
    "statusPaused": "Paused",
    "statusDone": "Done",
    "statusFailed": "Failed",
    "statusAbandoned": "Abandoned",
    "heading": "Goal",
    "refined": "Refined",
    "progress": "Progress",
    "iterations": "iterations",
    "deliverables": "Deliverables",
    "recentActivity": "Recent Activity"
  },
  "worktree": {
    "cleanTitle_one": "Clean {{count}} orphaned worktree?",
    "cleanTitle_other": "Clean {{count}} orphaned worktrees?",
    "cleanMessage": "Force-removes every leftover git worktree + wstack/ap branch from previous runs. Un-merged work in them is discarded.",
    "cleanConfirm": "Clean orphans",
    "orphanCount_one": "{{count}} orphaned worktree from previous runs",
    "orphanCount_other": "{{count}} orphaned worktrees from previous runs",
    "andMore": "…and {{count}} more",
    "cleanButtonTitle": "Force-remove all orphaned worktrees + branches",
    "removed_one": "✓ Removed {{count}} orphaned worktree.",
    "removed_other": "✓ Removed {{count}} orphaned worktrees.",
    "cleanupFailed": "cleanup failed",
    "lanesHeading": "Worktrees",
    "base": "base",
    "isolatedCount_one": "{{count}} isolated",
    "isolatedCount_other": "{{count}} isolated",
    "statusAllocating": "allocating",
    "statusActive": "active",
    "statusCommitting": "committing",
    "statusMerging": "merging",
    "statusMerged": "merged",
    "statusConflict": "conflict",
    "statusFailed": "failed",
    "conflictBadge": "CONFLICT",
    "graphAria": "Worktree branch graph off {{base}}",
    "mergedLabel": "✓ merged → {{base}}"
  },
  "process": {
    "heading": "Running Processes",
    "subtitle": "{{active}} active · {{total}} total",
    "killAll": "Kill All",
    "emptyTitle": "No processes tracked",
    "emptyBody": "Processes appear here when the agent runs bash or exec tools. Active processes show a pulsing LED.",
    "pidLabel": "PID {{pid}}",
    "protected": "protected",
    "protectedTitle": "Protected — survives kill/killAll",
    "killTitle": "Kill PID {{pid}}"
  },
  "diff": {
    "tooLarge": "Diff omitted (file too large to render inline)."
  },
  "fallback": {
    "placeholder": "Add a fallback model…",
    "emptyHint": "Tried in order when the primary model rate-limits or stalls.",
    "moveUp": "Move up",
    "moveDown": "Move down",
    "manualPlaceholder": "provider/model",
    "addTitle": "Add model reference"
  },
  "liveSessions": {
    "loading": "Loading sessions...",
    "apiUnavailable": "Session API unavailable:",
    "empty": "No live sessions. Open another wstack instance to see it here.",
    "heading": "Live Sessions ({{count}})",
    "autoRefresh": "auto-refresh every 5s",
    "pidLabel": "PID {{pid}}",
    "agentMeta": "{{iter}} iter · {{tools}} tools · {{ago}}",
    "andMore": "... and {{count}} more",
    "noAgents": "No agents"
  },
  "monacoDiff": {
    "applyTitle": "Write the edited version back to disk",
    "applying": "Applying…",
    "applied": "Applied",
    "apply": "Apply"
  },
  "errorBody": {
    "showStack_one": "Show stack trace ({{count}} frame)",
    "showStack_other": "Show stack trace ({{count}} frames)",
    "hideStack_one": "Hide stack trace ({{count}} frame)",
    "hideStack_other": "Hide stack trace ({{count}} frames)"
  },
  "officeMap": {
    "liveHeading": "Live",
    "clients": "Clients",
    "agents": "Agents",
    "model": "Model",
    "mode": "Mode",
    "toolCalls": "Tool calls",
    "displayHeading": "Display",
    "statsHud": "Stats HUD",
    "legends": "Legends",
    "minimap": "Minimap",
    "zoomControls": "Zoom controls",
    "animateWires": "Animate wires",
    "backgroundHeading": "Background",
    "bgDots": "Dots",
    "bgLines": "Lines",
    "bgCross": "Cross",
    "bgNone": "None"
  },
  "toolInput": {
    "noParams": "(no params)",
    "itemCount_one": "{{count}} item",
    "itemCount_other": "{{count}} items",
    "keyCount_one": "{{count}} key",
    "keyCount_other": "{{count}} keys"
  },
  "message": {
    "roleYou": "You",
    "roleTool": "Tool",
    "roleThinking": "Thinking",
    "roleAssistant": "Assistant",
    "inputLabel": "Input",
    "downloadTitle": "Download as file",
    "empty": "(empty)",
    "hideDetails": "Hide details",
    "showDetails": "Show details",
    "showDetailsLines_one": "Show details ({{count}} line)",
    "showDetailsLines_other": "Show details ({{count}} lines)",
    "editHint": "⌘/Ctrl+Enter to save · Esc to cancel",
    "saveResend": "Save & resend",
    "thinkingProcess": "Thinking process",
    "thinkingMeta": "iter {{iter}} · {{dur}} · {{lines}}",
    "replay": "replay",
    "linesSuffix_one": "{{count}} line",
    "linesSuffix_other": "{{count}} lines",
    "copyLog": "Copy log",
    "showFullLog": "Show full log",
    "typing": "Typing…",
    "noContent": "No content",
    "failedToSend": "⚠ Failed to send",
    "autoPaused": "⚠️ _Auto-proceed paused — maximum consecutive automatic turns reached. Type anything to continue (autonomy stays on)._",
    "rsIterations": "Iterations: {{n}}",
    "rsTools": "Tool calls: {{n}}",
    "rsElapsed": "Elapsed: {{s}}",
    "rsCost": "Cost: {{c}}",
    "useInput": "Input: {{n}}",
    "useOutput": "Output: {{n}}",
    "useCacheRead": "Cache read: {{n}}",
    "useCost": "Cost: {{c}}",
    "renderedLabel": "Rendered",
    "rawLabel": "Raw",
    "showRenderedTitle": "Show rendered markdown",
    "showRawTitle": "Show raw markdown source",
    "editTitle": "Edit & resend this prompt",
    "editLabel": "Edit",
    "unpinTitle": "Unpin",
    "pinTitle": "Pin this answer",
    "pinnedLabel": "Pinned",
    "pinLabel": "Pin",
    "regenerateTitle": "Regenerate this response",
    "retryLabel": "Retry"
  },
  "watch": {
    "toolFallback": "tool",
    "toolFailed": "Tool failed"
  },
  "shortcuts": {
    "heading": "Keyboard shortcuts",
    "footerPre": "Press",
    "footerPost": "any time to reopen this list.",
    "sectionGlobal": "Global",
    "sectionTuiParity": "TUI Panel Parity",
    "sectionFleet": "Fleet & Agents",
    "sectionChatInput": "Chat input",
    "sectionChat": "Chat",
    "sectionChatNav": "Chat navigation (when not typing)",
    "dCommandPalette": "Open command palette",
    "dShowOverlay": "Show this shortcuts overlay",
    "dToggleSidebar": "Toggle sidebar",
    "dOpenPanel": "Open side panel (Session, Agents, History, Files, Changes, Mailbox, Skills, Office Map)",
    "dDesignStudio": "Open Design Studio side panel",
    "dWorktrees": "Open Worktrees side panel",
    "dFocusInput": "Focus the message input",
    "dSessionPanel": "Session panel",
    "dFleetOverlay": "Fleet monitor overlay",
    "dAgentsOverlay": "Agents monitor overlay",
    "dWorktreeMonitor": "Worktree monitor",
    "dPlanPanel": "Plan panel",
    "dTodosPanel": "Todos panel",
    "dQueuePanel": "Queue panel",
    "dProcessMonitor": "Process monitor",
    "dGoalPanel": "Goal panel",
    "dSessionsDashboard": "Sessions dashboard",
    "dOfficeMap": "Coordinator office map",
    "dDockPicker": "Dock chip picker",
    "dOpenFleet": "Open Fleet Monitor overlay",
    "dOpenAgents": "Open Agents Monitor overlay",
    "dNavigateAgents": "Navigate agents in monitor",
    "dSelectAgent": "Select focused agent",
    "dCloseOverlay": "Close active overlay",
    "dSendMessage": "Send message",
    "dNewline": "Insert a newline",
    "dRecallPrev": "Recall previous prompt (in empty input)",
    "dRecallNext": "Recall next prompt",
    "dSlashPopup": "Open slash command popup",
    "dAutocomplete": "Autocomplete highlighted command",
    "dDismissPopup": "Dismiss popup / clear input",
    "dSearchChat": "Search within current chat",
    "dClearContext": "Clear context (same as /clear)",
    "dNewSession": "Start a new session (same as /new)",
    "dExportMarkdown": "Export chat as markdown",
    "dModelSwitcher": "Quick model switcher overlay",
    "dCompactDensity": "Toggle compact UI density",
    "dAbortRun": "Abort the current run (when running)",
    "dFocusNext": "Focus next message (alias: ↓)",
    "dFocusPrev": "Focus previous message (alias: ↑)",
    "dJumpFirst": "Jump to first message",
    "dJumpLast": "Jump to last message",
    "dCopyFocused": "Copy focused message text",
    "dClearFocused": "Clear focused message"
  },
  "sddBoard": {
    "titleFallback": "Live SDD Board",
    "defaultModelTitle": "Run-level default worker model (per-task overrides take precedence)",
    "graphLabel": "Graph",
    "kanbanLabel": "Kanban",
    "retryAllTitle": "Requeue every failed task to pending",
    "retryFailed": "Retry failed ({{count}})",
    "resume": "Resume",
    "pause": "Pause",
    "stop": "Stop",
    "cleanTitle": "Remove the run's git worktrees + wstack/ap branches",
    "cleanWorktrees": "Clean worktrees",
    "rollbackTitle": "Revert {{count}} merged commit(s) on {{base}}",
    "rollback": "Rollback ({{count}})",
    "stopping": "Stopping…",
    "destroying": "Destroying…",
    "destroyTitle": "Stop, remove all worktrees, optionally revert merged commits, and delete the SDD project",
    "destroy": "Destroy",
    "statDone": "done",
    "statRunning": "running",
    "statFailed": "failed",
    "statWave": "wave",
    "statElapsed": "elapsed",
    "noActiveWorkers": "no active workers",
    "deadlock": "Deadlock — tasks blocked by failed work:",
    "noRunTitle": "No active SDD run.",
    "noRunBody": "Start one from the New SDD Project wizard, or via /sdd execute in the CLI — agents appear here live, each working an isolated worktree.",
    "clickTaskHint": "click a task for details",
    "lcClean": "Clean",
    "lcRollback": "Rollback",
    "lcDestroy": "Destroy",
    "lcFailed": "{{op}} failed: {{reason}}",
    "lcUnknownError": "unknown error",
    "lcWorktrees_one": "{{count}} worktree removed",
    "lcWorktrees_other": "{{count}} worktrees removed",
    "lcCommits_one": "{{count}} commit reverted",
    "lcCommits_other": "{{count}} commits reverted",
    "lcDeleted": "deleted {{items}}",
    "lcNothing": "nothing to do",
    "lcNote": "{{op}}: {{body}} — note: {{reason}}",
    "lcOk": "{{op}}: {{body}}"
  },
  "sddTask": {
    "backTitle": "Back to activity",
    "workingOn": "working on this task",
    "assigned": "assigned",
    "metaPriority": "Priority",
    "metaType": "Type",
    "metaDuration": "Duration",
    "metaElapsed": "Elapsed",
    "metaRetries": "Retries",
    "metaWorktree": "Worktree",
    "workerModel": "Worker model",
    "runDefault": "run default: {{model}}",
    "runDefaultPlaceholder": "Run default",
    "runDefaultPlaceholderModel": "Run default ({{model}})",
    "verificationCmd": "Verification command",
    "gatesCompletion": "gates completion (exit 0)",
    "verifyPlaceholder": "e.g. pnpm vitest run path/to/file",
    "addVerify": "+ Add verification command",
    "description": "Description",
    "timeline": "Timeline",
    "dependsOn": "Depends on",
    "blocks": "Blocks",
    "newWorkerPlaceholder": "New worker name…",
    "confirmStop": "Stop this running task?",
    "confirmDelete": "Delete this task from the run?",
    "retryTitle": "Requeue this task to pending",
    "reassign": "Reassign",
    "stopTitle": "Abort the worker on this task",
    "splitTitle": "Split this task into sub-tasks delegated to separate workers",
    "split": "Split",
    "splitHint": "One sub-task per line — Title :: description (description optional)",
    "splitPlaceholder": "Write the data layer :: add the repository\nWire the UI",
    "splitInto": "Split into sub-tasks",
    "deleteTitle": "Remove this not-started task from the run"
  },
  "sddWizard": {
    "phaseStart": "Start",
    "phaseInterview": "Interview",
    "phaseSpecReview": "Spec Review",
    "phasePlanning": "Planning",
    "phaseTaskReview": "Task Review",
    "phaseRunning": "Running",
    "phaseDone": "Done",
    "titleFallback": "New SDD Project",
    "questionsSuffix": "{{cur}}/{{max}} questions",
    "tasksSuffix": "{{count}} tasks",
    "runCfgTitle": "Run config — default model + fallback chain",
    "modelsLabel": "Models",
    "startRun": "Start Run",
    "defaultWorkerModel": "Default worker model",
    "leaderDefaultPlaceholder": "Leader / session default",
    "useSessionDefault": "Use session default",
    "fallbackChain": "Fallback chain",
    "appliesToAll": "Applies to every task. Override per-task from the live board after the run starts.",
    "parallelAgents": "Parallel agents",
    "isolateWorktrees": "Isolate in git worktrees",
    "worktreeOn": "Each task runs in its own worktree, squash-merged back on completion.",
    "worktreeOff": "Tasks run directly on the current branch (no isolation).",
    "goalPrompt": "What do you want to build?",
    "goalPlaceholder": "e.g. Add OAuth login (Google + GitHub) with session management",
    "startingInterview": "Starting interview…",
    "startInterview": "Start Interview",
    "introBody": "An isolated agent interviews you to build a spec, decomposes it into a dependency-ordered task graph, then a real multi-agent fleet executes it — watch live on the board.",
    "taskGraphSummary": "Task graph · {{count}} tasks, dependency-ordered",
    "dragToExplore": "drag to explore",
    "show": "show",
    "goalLabel": "Goal",
    "implementationPlan": "Implementation plan",
    "approveSpec": "Approve spec → plan implementation",
    "approveTasks": "Approve tasks",
    "approvePlan": "Approve plan",
    "answerPlaceholder": "Answer the question…",
    "changePlaceholder": "Request a change…"
  },
  "fileExplorer": {
    "emptyDir": "empty",
    "loadFailed": "Failed to load files: {{error}}",
    "expandAllTitle": "Expand all directories",
    "expandAll": "Expand all",
    "collapseAllTitle": "Collapse all directories",
    "collapse": "Collapse",
    "folders_one": "{{count}} folder",
    "folders_other": "{{count}} folders",
    "currentDirTitle": "Current directory: {{path}}",
    "navigateToTitle": "Navigate to {{path}}",
    "filesSuffix_one": "{{count}} file",
    "filesSuffix_other": "{{count}} files",
    "goToDir": "go to dir",
    "navigateParentTitle": "Navigate to parent directory of {{path}}",
    "parentDirectory": "parent directory",
    "noFiles": "No files found",
    "copyAbsPath": "Copy absolute path",
    "copyRelPath": "Copy relative path",
    "openInTerminal": "Open in terminal",
    "openInFileManager": "Open in file manager",
    "mentionInChat": "Mention in chat",
    "copyPath": "Copy path"
  },
  "codeEditor": {
    "sendSelectionAction": "Send selection to chat",
    "noFilesOpen": "No files open",
    "selectToEdit": "Select a file from the explorer to start editing",
    "sendSelectedTitle": "Send selected lines to chat",
    "mentionFileTitle": "Mention this file in chat",
    "sendToChat": "Send to chat",
    "mentionFile": "Mention file",
    "loadingEditor": "Loading editor…",
    "selectTab": "Select a tab to view its content"
  },
  "analytics": {
    "loading": "Loading analytics…",
    "heading": "Analytics Dashboard",
    "autoRefresh": "auto-refresh every 10s",
    "liveSessions": "Live Sessions",
    "agents": "Agents",
    "agentsActive": "{{count}} active",
    "totalEvents": "Total Events",
    "categoriesSub": "{{count}} categories",
    "toolCalls": "Tool Calls",
    "iterationsSub": "{{count}} iterations",
    "sessionCost": "Session Cost",
    "tokensSub": "{{input}} in / {{output}} out",
    "sessionDuration": "Session Duration",
    "messagesSub": "{{count}} messages",
    "eventsByCategory": "Events by Category",
    "noEvents": "No events recorded yet.",
    "topEvents": "Top Events",
    "activeSessionUsage": "Active Session Usage",
    "provider": "Provider",
    "model": "Model",
    "inputTokens": "Input Tokens",
    "outputTokens": "Output Tokens",
    "cacheRatio": "Cache Ratio",
    "filesRead": "Files Read",
    "noSession": "No active session or waiting for data…",
    "healthErrors": "Health & Errors",
    "errorEvents": "Error events",
    "warningEvents": "Warning events",
    "cacheHitRate": "Cache hit rate",
    "totalCategories": "Total categories",
    "waitingData": "Waiting for data…",
    "recentEvents": "Recent Events",
    "noRecentEvents": "No recent events. Interact with the UI to generate events."
  },
  "promptLib": {
    "heading": "Prompt library",
    "searchPlaceholder": "Search prompts…",
    "newPrompt": "＋ New prompt",
    "all": "All",
    "recent": "🕘 Recent",
    "favorites": "★ Favorites",
    "noMatch": "No prompts match.",
    "newPromptHeading": "New prompt",
    "titlePlaceholder": "Title *",
    "descPlaceholder": "One-line description",
    "categoryPlaceholder": "Category",
    "tagsPlaceholder": "tags, comma, separated",
    "contentPlaceholder": "Prompt content * — use {{name}} for variables",
    "variables": "Variables",
    "addVar": "＋ var",
    "varNamePlaceholder": "name",
    "varDescPlaceholder": "description",
    "removeVarTitle": "Remove variable",
    "required": "required",
    "multiline": "multiline",
    "enumPlaceholder": "enum: a, b, c",
    "savePrompt": "Save prompt",
    "saveFailed": "Could not save the prompt.",
    "titleContentRequired": "Title and content are required.",
    "toggleFavoriteTitle": "Toggle favorite",
    "selectOption": "— select —",
    "fillMissing": "Fill: {{missing}}",
    "insertIntoChat": "Insert into chat",
    "selectPromptHint": "Select a prompt to preview and insert."
  },
  "skillDetail": {
    "scopeProject": "Project",
    "scopeGlobal": "Global",
    "scopeBundled": "Bundled",
    "timeoutError": "Request timed out. Please try again.",
    "updateFailed": "Update failed",
    "saveFailed": "Save failed",
    "uninstallFailed": "Uninstall failed",
    "noSkillSelected": "No skill selected",
    "selectSkillHint": "Select a skill from the sidebar to view its documentation",
    "goToChat": "Go to chat",
    "openSourceRepo": "Open source repo",
    "copySourceUrl": "Copy source URL",
    "updatedLabel": "↑ Updated: {{list}}",
    "upToDateLabel": "— Up to date: {{list}}",
    "errorsLabel": "✗ {{list}}",
    "checkUpdatesTitle": "Check for updates",
    "exportTitle": "Export skill as .md",
    "editTitle": "Edit skill",
    "uninstallTitle": "Uninstall skill",
    "closeTitle": "Close and go to chat",
    "backTitle": "Go back",
    "forwardTitle": "Go forward",
    "relatedFiles": "Related Files",
    "references": "References",
    "goToSkillTitle": "Go to {{name}}",
    "loadingContent": "Loading skill content…",
    "editingLabel": "Editing {{name}}",
    "editStats": "{{lines}} lines · {{words}} words · {{chars}} chars",
    "charsWarningFmt": "⚠ {{used}} MB / {{limit}} MB",
    "draftSaved": "Draft saved",
    "draftRestored": "Draft restored",
    "discardDraft": "Discard draft",
    "splitViewTitle": "Split view",
    "hidePreviewTitle": "Hide preview",
    "contentPlaceholder": "Skill content (markdown)...",
    "loadFailed": "Failed to load skill content",
    "noContent": "No skill content available",
    "uninstallSkillHeading": "Uninstall Skill",
    "uninstallConfirm": "Uninstall {{name}}?",
    "uninstallRemovePath": "This will remove the skill from {{path}} and cannot be undone.",
    "uninstallAction": "Uninstall"
  },
  "office": {
    "sessionStats": "Session Stats",
    "clients": "Clients",
    "input": "Input",
    "output": "Output",
    "cost": "Cost",
    "agentsSuffix": "agents",
    "upPrefix": "up {{time}}",
    "webuiClient": "WebUI Client",
    "disconnected": "Disconnected",
    "connected": "Connected",
    "tuiClient": "TUI Client",
    "terminal": "Terminal",
    "repl": "REPL",
    "coordinator": "COORDINATOR",
    "fleetSummary": "Fleet summary",
    "toolCallsLabel": "Tool calls",
    "tokensLabel": "Tokens",
    "coordinatingFleet": "Coordinating fleet",
    "donePrefix": "✓ done ·",
    "failedPrefix": "✕ failed ·",
    "seenPrefix": "seen {{time}}",
    "availableDesk": "Available desk",
    "mailboxHub": "Mailbox Hub",
    "unreadSuffix_one": "{{count}} unread",
    "unreadSuffix_other": "{{count}} unread",
    "allClear": "All clear",
    "total": "Total",
    "unreadLabel": "Unread",
    "liveActivity": "Live activity",
    "waitingActivity": "Waiting for activity…",
    "now": "now",
    "fleetHq": "WrongStack Fleet HQ",
    "live": "LIVE",
    "legendStatus": "Status",
    "legendActive": "Active",
    "legendIdle": "Idle",
    "legendError": "Error",
    "legendConnections": "Connections",
    "legendMail": "Mail",
    "legendTask": "Task",
    "legendStatusConn": "Status",
    "arrange": "Arrange",
    "arrangeTitle": "Snap nodes back to the floor plan",
    "feed": "Feed",
    "feedTitle": "Toggle the live activity feed",
    "broadcast": "Broadcast",
    "broadcastTitle": "Broadcast a message to every live session in this project",
    "broadcastToAll": "Broadcast to all sessions",
    "broadcastPlaceholder": "Message every live agent in this project…",
    "broadcastSendHint": "⌘/Ctrl+Enter to send",
    "openFullView": "Open full operation view",
    "rowStatus": "Status",
    "rowModel": "Model",
    "rowTool": "Tool",
    "rowIterations": "Iterations",
    "rowToolCalls": "Tool calls",
    "rowTokensIn": "Tokens in",
    "rowTokensOut": "Tokens out",
    "rowTokensTotal": "Tokens total",
    "rowContext": "Context",
    "rowCost": "Cost",
    "rowLastSeen": "Last seen",
    "rowSurface": "Surface",
    "rowBranch": "Branch",
    "rowPid": "PID",
    "rowDir": "Dir",
    "rowAgents": "Agents",
    "rowUptime": "Uptime",
    "rowConnections": "Connections",
    "rowTotalMessages": "Total messages",
    "rowUnread": "Unread",
    "recent": "Recent",
    "noSubject": "(no subject)",
    "fullOperationStream": "Full operation stream",
    "closeEsc": "Close (Esc)",
    "idleDesk": "Idle desk",
    "fleetHqLabel": "Fleet HQ",
    "clientsSuffix_one": "{{count}} client",
    "clientsSuffix_other": "{{count}} clients",
    "taskFallback": "task",
    "controlLabel": "control"
  },
  "skillsList": {
    "installTitle": "Install skill",
    "createTitle": "Create skill",
    "exportTitle": "Export all skills as .zip",
    "checkUpdatesTitle": "Check for updates (all skills)",
    "searchPlaceholder": "Search skills…",
    "loading": "Loading…",
    "noSkills": "No skills installed",
    "noMatch": "No skills match filter",
    "noDescription": "No description",
    "scopeForeign": "Foreign",
    "installHeading": "Install Skill",
    "installHint": "Enter a GitHub repository reference (owner/repo) or full URL.",
    "installPlaceholder": "e.g. wrongstack/skill-name or https://github.com/owner/repo",
    "installScope": "Install scope:",
    "installBtn": "Install",
    "installedMsg": "Installed: {{names}}",
    "installFailed": "Installation failed",
    "createHeading": "Create Skill",
    "createHint": "Scaffold a new skill. The first line is the trigger; additional lines form the description.",
    "nameLabel": "Name",
    "namePlaceholder": "e.g. my-new-skill",
    "descLabel": "Description / Trigger",
    "descPlaceholder": "Use this skill when <trigger situation>.\nTriggers: user says \"keyword\", \"another\".",
    "saveIn": "Save in:",
    "createBtn": "Create Skill",
    "createdMsg": "Created: {{name}}",
    "createFailed": "Creation failed"
  },
  "timeline": {
    "noEvents": "No events yet."
  },
  "designStudio": {
    "pickHint": "Pick a kit — the agent will adhere to it.",
    "gallery": "Gallery",
    "galleryTitle": "Open live preview gallery",
    "stackTitle": "Target stack",
    "loading": "Loading kits…",
    "notFound": "No design kits found.",
    "bestFor": "Best for:",
    "light": "Light",
    "dark": "Dark"
  },
  "worktrees": {
    "detached": "(detached)",
    "count_one": "{{count}} worktree",
    "count_other": "{{count}} worktrees",
    "baseSuffix": " · base {{base}}",
    "baseLabel": "base",
    "cleanOrphans": "Clean orphans",
    "cleanOrphansTitle": "Remove all orphaned worktrees",
    "liveBusyTitle": "A run is live — stop it first",
    "rescanTitle": "Rescan",
    "removed_one": "Removed {{count}} worktree.",
    "removed_other": "Removed {{count}} worktrees.",
    "failed": "Failed",
    "mergedIntoBase": "Merged {{branch}} into base.",
    "conflictMerge": "Conflict merging {{branch}}: {{files}}",
    "seeGit": "see git",
    "mergeFailed": "Merge failed: {{reason}}",
    "unknownReason": "unknown",
    "mergeConfirmTitle": "Merge {{branch}} into {{base}}?",
    "mergeConfirmMsg": "Squash-merges this branch onto the base branch. Aborts cleanly if it conflicts.",
    "mergeAction": "Merge",
    "removeConfirmTitle": "Remove {{branch}}?",
    "removeConfirmMsg": "Force-removes the worktree checkout and deletes its branch. Un-merged work is discarded.",
    "empty": "No worktrees.",
    "emptyHint": "SDD / AutoPhase runs create isolated worktrees here. Orphans from crashed runs show up too.",
    "actOpenTerm": "Open in terminal",
    "actOpenFolder": "Open folder",
    "actViewChanges": "View changes",
    "actMerge": "Merge to base",
    "actRemove": "Remove / discard",
    "live": "live",
    "noUncommitted": "No uncommitted changes",
    "commitsAhead_one": "{{count}} commit ahead",
    "commitsAhead_other": "{{count}} commits ahead",
    "more": "…{{count}} more"
  },
  "officeSettings": {
    "heading": "Office Map",
    "headingHint": "Visualize your fleet as an office floor plan with live agent status.",
    "statAgents": "Agents",
    "statMail": "Mail",
    "unreadSuffix": " unread",
    "sectionView": "View",
    "sectionDisplay": "Display",
    "sectionBackground": "Background",
    "sectionRecent": "Recent Activity",
    "eventsTrackedSuffix": " events tracked",
    "recentHint": "Mail sends, agent spawns, and status changes appear here.",
    "sectionShortcuts": "Shortcuts",
    "sectionLegend": "Legend",
    "hudLabel": "HUD",
    "hudDesc": "Show real-time session stats overlay",
    "hudToggle": "Toggle HUD",
    "minimapLabel": "Minimap",
    "minimapDesc": "Show the overview minimap",
    "minimapToggle": "Toggle minimap",
    "controlsLabel": "Controls",
    "controlsDesc": "Show zoom and fit controls",
    "controlsToggle": "Toggle controls",
    "animateLabel": "Animate edges",
    "animateDesc": "Animate flow on active connections",
    "animateToggle": "Toggle edge animation",
    "legendLabel": "Show legend",
    "legendDesc": "Display status and connection legend",
    "legendToggle": "Toggle legend",
    "feedLabel": "Live feed",
    "feedDesc": "Bottom strip of recent cross-process activity",
    "feedToggle": "Toggle live feed",
    "fitView": "Fit view",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "resetZoom": "Reset zoom",
    "legendActive": "Active (running)",
    "legendIdle": "Idle",
    "legendError": "Error",
    "legendOffline": "Offline",
    "bg": {
      "dots": "Dots",
      "lines": "Lines",
      "cross": "Cross",
      "none": "None"
    }
  }
}
